import React from "react";
import styled from "styled-components";

import BookMockEnImg from "./book-mock-en.png";
import BookMockEsImg from "./book-mock-es.png";
import BookMockFrImg from "./book-mock-fr.png";

import starsImg from "./stars.png";
import { ButtonA } from "components/_core/Button";
import { appleBuyLink, audibleBuyLink, bookshopBuyLink, kindleBuyLink } from "./constants";

const Wrap = styled.div`
    border-top: #ff7a57 10px solid;
    padding: 20px 0;
    background-color: #264360;
`;

const Container = styled.div`
    max-width: 900px;
    margin: 0 auto;
    text-align: center;

    padding: 15px;

    display: flex;
    justify-content: center;
    align-items: center;

    @media screen and (max-width: 700px) {
        flex-direction: column;
    }
`;

const Column = styled.div`
    height: 100%;
`;

const BookColumn = styled(Column)`
    flex-basis: 60%;
    flex-shrink: 0;
    margin-right: -100px;
`;


const BookMock = styled.img`
    width: 100%;
    height: 100%;
    object-fit: contain;
    object-position: center;

    @media screen and (max-width: 700px) {
        max-width: 400px;
    }
`;

const DetailsColumn = styled(Column)`
    text-align: center;

`;

const Stars = styled.img`
    width: 130px;
    margin: 0 auto;
`;

const Testimonial = styled.div`
    color: #fff;
    font-size: 1.2rem;
    margin-top: 5px;

    p {
        margin: 0;
    }
`;

const BuyButtons = styled.div`
    max-width: 400px;
    margin: 20px auto;
`;

export const BuyButton = styled(ButtonA)`
    text-transform: none;

    padding: 20px 30px;
    width: 100%;
    
    border: 3px solid #fff;
    background-color: #ffd712;
    box-shadow: 0px 6px 0 0 #00000021;
    color: #000;

    border-radius: 10px;

    // margin: 30px 0;
    font-size: 22px;
    font-weight: 600;

    &:hover {
        background-color: #ffd712 !important;
        opacity: 0.9;
    }

    ${props => {
        if (props.$orange) {
            return `
                background-color: #e5712d;
                color: #fff;

                &:hover {
                    background-color: #e5712d !important;
                }
            `;
        }
        if (props.$purple) {
            return `
                background-color: #4e3f89 !important;
                color: #fff;

                &:hover {
                    background-color: #4e3f89 !important;
                }
            `;
        }
        if (props.$blue) {
            return `
                background-color: #4151ad !important;
                color: #fff;

                &:hover {
                    background-color: #4151ad !important;
                }
            `;
        }
        if (props.$red) {
            return `
                background-color: #b04542 !important;
                color: #fff;

                &:hover {
                    background-color: #b04542 !important;
                }
            `;
        }
    }}
    ${props => {
        if (props.$small) {
            return `
                padding: 10px 15px;
                font-size: 16px;
            `;
        }
    }}
`;

const AdditionalButtons = styled.div`
    display: flex;
    justify-content: center;
    margin-top: 10px;

    flex-wrap: wrap;

    margin: 5px -5px;
`;

const ButtonWrap = styled.div`
    padding: 5px;
    flex-basis: 50%;
    flex-grow: 0;
    flex-shrink: 0;
`;

const SitePlug = styled.div`
    color: #fff;

    max-width: 350px;
    margin: 0 auto;

    h2 {
        font-size: 1.5rem;
    }

    p {
        font-size: 1.1rem;
    }

    a {
        color: #fff;
    }
`;

const Plug = styled.p`
    display: block;

    font-size: 1rem;
    background-color: #ff7a57;
    padding: 5px;
    font-weight: 700;
`;

const BookTop = ({ lang, text, showAdditionalBuyButtons }) => {
    const mocks = {
        en: BookMockEnImg,
        es: BookMockEsImg,
        fr: BookMockFrImg
    };
    
    const BookMockImg = mocks[lang] || BookMockEnImg;
    
    return (
        <Wrap>
            <Container>
                <BookColumn>
                    <BookMock src={BookMockImg} />
                </BookColumn>
                <DetailsColumn>
                    <Stars src={starsImg} alt="5 Stars" />
                    <Testimonial>
                        <p>{text.pullQuote}</p>
                        <p>&mdash; <em>{text.pullQuoteAuthor}</em></p>
                    </Testimonial>

                    <BuyButtons>
                        <BuyButton href={text.buyButtonLink} rel="noopener noreferrer"  target="_blank"
                        className="btn" bold pill large>{text.buyButtonText}</BuyButton>

                        {showAdditionalBuyButtons && <AdditionalButtons>
                            <ButtonWrap>
                                <BuyButton href={kindleBuyLink} rel="noopener noreferrer"  target="_blank" $small>Kindle</BuyButton>
                            </ButtonWrap>
                            <ButtonWrap>
                                <BuyButton href={audibleBuyLink} rel="noopener noreferrer"  target="_blank" $small>Audible</BuyButton>
                            </ButtonWrap>
                            <ButtonWrap>
                                <BuyButton href={appleBuyLink} rel="noopener noreferrer"  target="_blank" $small $orange>Apple Books</BuyButton>
                            </ButtonWrap>
                            <ButtonWrap>
                                <BuyButton href={bookshopBuyLink} rel="noopener noreferrer"  target="_blank" $small $purple>Bookshop.org</BuyButton>
                            </ButtonWrap>
                            <ButtonWrap>
                                <BuyButton href="/delabatterie" $small $blue>En français</BuyButton>
                            </ButtonWrap>
                            <ButtonWrap>
                                <BuyButton href="/sobrelabateria" $small $red>En Español</BuyButton>
                            </ButtonWrap>
                        </AdditionalButtons>}
                    </BuyButtons>

                    <SitePlug>
                        <h2>{text.promoHeading}</h2>
                        <Plug>{text.promoSubtext}</Plug>
                        <p>{text.promoText}</p>
                    </SitePlug>

                </DetailsColumn>
            </Container>
        </Wrap>
    )
};

export default BookTop;
